import React                     from 'react';
import EntityListView, {
  EntityListProps,
  IEntityListProps,
  styles,
}                                from './EntityListView';
import RoutedEntityListCardView  from './RoutedEntityListCardView';
import { withStyles }            from '../utility/styles';
export type { EntityListProps, IEntityListProps };
export { styles };

class RoutedEntityListView extends React.PureComponent<EntityListProps> {
  constructor(props: EntityListProps) {
    super(props);
  }

  render() {
    return (
      <EntityListView cardViewRenderer={RoutedEntityListCardView} hidePaging={true} {...this.props} />
    );
  }
}

export default withStyles<IEntityListProps>(styles, RoutedEntityListView);
